CoinCollectionView = {
  //PARAMS\\

  tempTextFont: "cashFishFontSpinningCoins",
  progressionBarName: "postReels:CoinCounterContainer",
  collectBoxPath: "Base_Game/cashCollectBox.png",
  prizePotMapping: { Mini: "tiddler", Minor: "lunker", Major: "whopper", Mega: "monster" },
  collectorBoxes: [],
  tempCashTexts: [],
  tempCashPotTexts: [],
  tempParticles: [],
  progresionBarEmitter: null,

  // TWEEN VALUES
  cashCollectionStagger: 200,

  // COLLECTOR VALUES
  collectorRunningTotal: 0,

  // FREE SPINS TRIGGER
  freeSpinsCounter: null,
  freeSpinsCounterValue: null,

  // TWEENS
  smartTweens: null, // little helper for tweens (automatically readjusts tweens on orientation change)
  particleTweensInProgress: false,
  cashTextTweensInProgress: false,

  //FUNCTIONS\\
  initialise() {
    this.createProgressionBarEmitter();
    Reflex.registerEventHandler("layoutChange", this.orientationChange.bind(this));

    this.freeSpinsCounter = resourceManager.get("postReels:freespinsCounter");
    this.freeSpinsCounterValue = resourceManager.get("postReels:freespinsCounter:value");

    this.cashCoinAmountContainer = resourceManager.get("postReels:cashCoinAmountContainer");

    this.smartTweens = SmartTweens;
    //this.smartTweens.initialise();
  },

  createProgressionBarEmitter() {
    this.progresionBarEmitter = particleManager.createEmitter(
      "coinCounter",
      "postReels:coinCounterParticleCounter",
      0,
      0,
      false
    );

    this.progresionBarEmitter.particleEmitter.emit = false;
    this.progresionBarEmitter.visible = false;
  },

  createTempAssets() {
    const isCashCollectables = CoinCollectionModel.collectableSymbolsOnReel.cashSymbols.length;
    const isPotCollectables = CoinCollectionModel.collectableSymbolsOnReel.prizePotSymbols.length;
    const isBonusCollectables = CoinCollectionModel.collectableSymbolsOnReel.bonusSymbols.length;

    const hasCollectables = isCashCollectables || isPotCollectables || isBonusCollectables;

    if (hasCollectables) {
      const shouldCreateCollectorBoxes = this.collectorBoxes.length === 0 && (isCashCollectables || isPotCollectables);

      if (shouldCreateCollectorBoxes) {
        this.createCollectorBoxes();
      }

      this.createTempParticles();
    }

    if (isCashCollectables) {
      this.createTempCashTexts();
    }

    if (isPotCollectables) {
      this.createTempPotCashTexts();
    }
  },

  createCollectorBoxes() {
    CoinCollectionModel.collectorSymbolsOnReel.forEach((collector, index) => {
      const collectorSymbol = resourceManager.get(
        `slotContainer:reelContainer:reel${collector.reel}:symbol${collector.row}`
      );
      const collectBox = resourceManager.createObject(
        "sprite",
        `cashCollectBox${index}`,
        "slotContainer:reelContainer",
        {
          anchor: 0.5,
          fileName: this.collectBoxPath,
          x: 0,
          y: 0,
        }
      );

      collectBox.visible = false;

      const collectBoxText = resourceManager.createObject("text", `cashCollectBoxText${index}`, collectBox, {
        text: gdk.formatCurrency(0),
        fontDefinition: "cashFishFontCollectBox",
        x: 0,
        y: 2,
        anchor: 0.5,
      });

      this.collectorBoxes.push({
        collectorSymbol,
        collectBox,
        collectBoxText,
        runningTotal: 0,
      });
    });
    this.positionCollectorBoxes();
  },

  positionCollectorBoxes() {
    this.collectorBoxes.forEach((collectorBox) => {
      const { collectorSymbol, collectBox } = collectorBox;
      const collectBoxPos = helper.getLocalFromGlobalPosition(collectorSymbol, collectBox);

      collectBox.x = collectBoxPos.x;
      collectBox.y = collectBoxPos.y + 35;
    });
  },

  createTempCashTexts() {
    const self = this;
    // CREATE ALL TEMP TEXTS FOR CASH COLLECTABLES
    CoinCollectionModel.collectableSymbolsOnReel.cashSymbols.forEach((cashSymbol) => {
      const { reel, row } = cashSymbol.coin.coord;
      const originalSymbolText = resourceManager.get(
        `slotContainer:reelContainer:reel${reel}:symbol${row}:overlayTextContainer:reel${reel}:row${row}`
      );

      const { text, maxWidthDisplay, anchor } = originalSymbolText;
      const tempText = resourceManager.createObject(
        "text",
        `CoinCollectTemp${self.tempCashTexts.length}`,
        "postReels:PrizePotsReelContainer",
        {
          text: text,
          fontDefinition: self.tempTextFont,
          x: 0,
          y: 0,
          maxWidth: maxWidthDisplay,
          anchor: anchor,
        }
      );

      tempText.visible = true;
      //text.visible = true;
      //originalSymbolText.visible = false;

      this.tempCashTexts.push({
        originalSymbolText,
        tempText,
        winAmount: cashSymbol.winAmount,
        originalTextScale: originalSymbolText.scale.x,
        collectCoord: cashSymbol.collectCoord,
      });
    });
    this.positionTempTexts();
  },

  positionTempTexts() {
    const slotContainer = resourceManager.get("slotContainer");
    this.tempCashTexts.forEach((t) => {
      const { originalSymbolText, tempText } = t;
      // Position temp text
      const originalSymbolTextPos = helper.getLocalFromGlobalPosition(originalSymbolText, tempText, false);

      tempText.x = originalSymbolTextPos.x;
      tempText.y = originalSymbolTextPos.y;

      const newScale = t.originalTextScale * slotContainer.scale.x;

      tempText.scale.set(newScale);
    });
  },

  createTempPotCashTexts() {
    const self = this;
    CoinCollectionModel.collectableSymbolsOnReel.prizePotSymbols.forEach((prizePotSymbol) => {
      const { collectCoord, winAmount } = prizePotSymbol;
      const { potName } = prizePotSymbol.coin;

      const prizePotType = this.prizePotMapping[potName];
      const originalPrizePotText = resourceManager.get(`postReels:PrizePotsContainer:${prizePotType}CashText`);

      const { text, maxWidthDisplay, anchor } = originalPrizePotText;
      const tempText = resourceManager.createObject(
        "text",
        `PotCollectTemp${self.tempCashPotTexts.length}`,
        "postReels:PrizePotsReelContainer",
        {
          text: text,
          fontDefinition: "potPrizeFont",
          x: 0,
          y: 0,
          maxWidth: maxWidthDisplay,
          anchor: anchor,
        }
      );

      tempText.visible = true;
      //originalSymbolText = false;

      this.tempCashPotTexts.push({
        originalPrizePotText,
        tempText,
        winAmount,
        originalTextScale: originalPrizePotText.scale.x,
        collectCoord,
      });
    });
    this.positionTempPotCashTexts();
  },

  positionTempPotCashTexts() {
    const prizePotsContainer = resourceManager.get("postReels:PrizePotsContainer");
    this.tempCashPotTexts.forEach((t) => {
      const { originalPrizePotText, tempText } = t;

      const originalPrizePotPos = helper.getLocalFromGlobalPosition(originalPrizePotText, tempText, false);

      tempText.x = originalPrizePotPos.x;
      tempText.y = originalPrizePotPos.y;

      tempText.scale.set(t.originalTextScale * prizePotsContainer.scale.x);
    });
  },

  createTempParticles() {
    CoinCollectionModel.coinAwards.forEach((award) => {
      const emitter = particleManager.createEmitter("cashcoinParticle", "particlesContainerFront", 0, 0, false);

      emitter.particleEmitter.emit = false;
      emitter.visible = false;

      this.tempParticles.push({
        emitter,
        award,
      });
    });
    this.positionTempParticles();
  },

  positionTempParticles() {
    this.tempParticles.forEach((tempParticle) => {
      const { emitter, award } = tempParticle;

      const { reel, row } = award.coin.coord;
      const originalSymbol = resourceManager.get(`slotContainer:reelContainer:reel${reel}:symbol${row}`);
      const originalSymbolPos = helper.getLocalFromGlobalPosition(originalSymbol, emitter);

      emitter.particleEmitter.spawnPos.x = originalSymbolPos.x;
      emitter.particleEmitter.spawnPos.y = originalSymbolPos.y;
    });
  },

  async doProgressionBarCollection() {
    // Animate the Collect symbol(s)
    CoinCollectionModel.collectorSymbolsOnReel.forEach((collector) => {
      const collectorSymbolInfo = {
        cell: {
          reel: collector.reel,
          row: collector.row,
        },
        symbolId: 14,
      };
      spineSymbolAnimator.animate([collectorSymbolInfo]);
    });

    soundManager.play("collectAnimate");
    gameController.checkBackgroundThemeLevels();

    this.tempCashTexts.forEach((tempText) => {
      const originalScale = tempText.tempText.scale.x;
      gsap.to(tempText.tempText.scale, {
        duration: 0.25,
        ease: "power1.inOut",
        y: originalScale * 1.1,
        x: originalScale * 1.1,
        yoyo: true,
        repeat: 1,
      });
    });

    // Get the symbol info of all symbols that are to animate
    CoinCollectionModel.coinAwards.forEach((award) => {
      const { reel, row } = award.coin.coord;
      const originalSymbolInfo = helper.getCoinSymbolsFromReelPosition(reel, row);
      spineSymbolAnimator.animate([originalSymbolInfo]);
    });

    // Tween all of the particles emitters to the progression bar
    const progressionBar = resourceManager.get("postReels:CoinCounterContainer:coinCollectMeterFont");
    soundManager.play("coinWhoosh");
    const particleTweenPromises = this.tempParticles.map(async (tempParticle) => {
      tempParticle.emitter.particleEmitter.emit = true;
      tempParticle.emitter.visible = true;

      this.particleTweensInProgress = true;

      const xOnlyTween = this.smartTweens.tween(
        tempParticle.emitter.particleEmitter.spawnPos,
        progressionBar,
        tempParticle.emitter,
        { ease: "linear", duration: 0.5, y: false },
        false
      );

      const yOnlyTween = this.smartTweens.tween(
        tempParticle.emitter.particleEmitter.spawnPos,
        progressionBar,
        tempParticle.emitter,
        {
          ease: "power3.in",
          duration: 0.5,
          x: false,
        },
        false
      );
      await Promise.all([yOnlyTween, xOnlyTween]);
      this.particleTweensInProgress = false;
      tempParticle.emitter.particleEmitter.emit = false;
      tempParticle.emitter.visible = false;
    });

    // Wait for all the particles to tween over to progression bar
    await Promise.all(particleTweenPromises);

    this.progresionBarEmitter.particleEmitter.emit = true;
    this.progresionBarEmitter.visible = true;

    const respinAwarded = CloverRespins.respinData.isAwarded;
    soundManager.play(respinAwarded ? "cloverWon" : "coinBurst");

    stakeController = resourceManager.getController("stakeController");
    gameController.updateCounterState(gameController.globalHelperGetCurrentModeStake());

    gameController.updateCounters();
  },

  async doCashCollection() {
    const collectionAnimations = [];
    this.cashTextTweensInProgress = true;

    this.collectorBoxes.forEach((collectorBox) => {
      collectorBox.collectBox.visible = true;
    });

    for (const [collectorIndex, collector] of CoinCollectionModel.collectorSymbolsOnReel.entries()) {
      const collectorBox = this.collectorBoxes[collectorIndex];

      // PLAY COLLECTOR ANIMATION
      const spine = spineSymbolAnimator.animate(
        [{ cell: { reel: collector.reel, row: collector.row }, symbolId: 14 }],
        undefined,
        undefined,
        true
      )[0]; // true = loop

      // make sure always at the top
      collectorBox.collectBox.parent.setChildIndex(
        collectorBox.collectBox,
        collectorBox.collectBox.parent.children.length - 1
      );

      gameController.coinsCurrentlySkippable = true;
      gameController.canSkipWin = true;
      let delayIndex = 0;
      // Animate all *CASH* collectables for this collector
      for (const cashText of this.tempCashTexts) {
        // Start animating cash values to the collect symbol \\
        if (cashText.collectCoord.reel === collector.reel && cashText.collectCoord.row === collector.row) {
          const textToCollectorAnim = this.animateTextToCollector(collectorBox, cashText, delayIndex * 500);
          collectionAnimations.push(textToCollectorAnim);
          delayIndex++;
        }
      }

      // Animate all *POT* collectables for this collector
      for (const potText of this.tempCashPotTexts) {
        if (potText.collectCoord.reel === collector.reel && potText.collectCoord.row === collector.row) {
          const textToCollectorAnim = this.animateTextToCollector(collectorBox, potText, delayIndex * 500);
          collectionAnimations.push(textToCollectorAnim);
          delayIndex++;
        }
      }

      await Promise.all(collectionAnimations);
      spine.spineObject.state.clearTrack(0);
      spine.endedCallback();
    }
    this.cashTextTweensInProgress = false;
  },

  async animateTextToCollector(collectorBox, cashText, delay = 0) {
    const collectBoxText = collectorBox.collectBoxText;
    //get position to tween cash text to
    const targetPos = helper.getLocalFromGlobalPosition(collectBoxText, cashText.tempText);

    const cashTextYAnchor = cashText.tempText.anchor.y;
    const targetPosYOffset = cashTextYAnchor === 1 ? collectBoxText.height / 2 : 0;

    targetPos.y += targetPosYOffset;

    const disX = targetPos.x - cashText.tempText.x;
    const disY = targetPos.y - cashText.tempText.y;

    const distance = Math.sqrt(disX * disX + disY * disY);

    // pixels per second
    const SPEED = 250;

    // cap distances so it doesn't happen too fast/slwo
    const MIN_DISTANCE = 50;
    const MAX_DISTANCE = 400;

    const MIN_DURATION = MIN_DISTANCE / SPEED;
    const MAX_DURATION = MAX_DISTANCE / SPEED;

    const rawDuration = distance / SPEED;
    const duration = Math.min(MAX_DURATION, Math.max(MIN_DURATION, rawDuration));

    cashText.tempText.visible = true;

    // created this as will want to work on correct delays
    const tweenOnStart = () => {
      if (cashText.tempText.parent) {
        // always make sure it's above the rest
        cashText.tempText.parent.setChildIndex(cashText.tempText, cashText.tempText.parent.children.length - 1);
      }
      soundManager.play("coinWhoosh");
    };

    this.smartTweens.tween(
      cashText.tempText,
      collectorBox.collectBox,
      undefined,
      {
        duration: duration,
        ease: "power1.inOut",
        delay: delay / 1000,
        onStart: tweenOnStart,
      },
      true
    );

    const originalScale = cashText.tempText.scale.x;
    const scaleAnim = this.smartTweens.timeline(() =>
      gsap
        .timeline({ delay: delay / 1000 })
        .to(cashText.tempText.scale, {
          x: originalScale * 2,
          y: originalScale * 2,
          duration: duration / 2,
          ease: "power2.out",
        })
        .to(cashText.tempText.scale, {
          x: originalScale,
          y: originalScale,
          duration: duration / 2,
          ease: "power2.in",
        })
    );

    await scaleAnim;
    cashText.tempText.visible = false;
    collectorBox.runningTotal += cashText.winAmount;
    collectBoxText.text = gdk.formatCurrency(collectorBox.runningTotal);

    const bounds = collectBoxText.getLocalBounds();
    const scale = Math.min(1, 150 / bounds.width);

    collectBoxText.scale.set(scale);
  },

  async doBonusCollection() {
    let freeSpinsAmountsAdded = 0;
    // reposition temp particles
    this.positionTempParticles();
    //show free spins counter
    if (!gameController.inFreeSpins) {
      this.freeSpinsCounter.visible = true;
      this.freeSpinsCounter.alpha = 1;
      this.freeSpinsCounterValue.visible = false;
      const buyABonusButton = resourceManager.get("buttonContainer:buttonBar:buyBonusButton");
      const goldenBetButton = resourceManager.get("buttonContainer:buttonBar:luckyBetToggleButton");
      buyABonusButton.visible = false;
      goldenBetButton.visible = false;
    }

    //for each collector, tween particle over to free spins counter text
    for (const [collectorIndex, collector] of CoinCollectionModel.collectorSymbolsOnReel.entries()) {
      this.positionTempParticles();
      // Animate collector symbol
      spineSymbolAnimator.animate(
        [{ cell: { reel: collector.reel, row: collector.row }, symbolId: 14 }],
        undefined,
        undefined,
        false
      );

      // bonus collection for each bonus symbol for this collector
      for (const bonusSymbol of CoinCollectionModel.collectableSymbolsOnReel.bonusSymbols) {
        if (bonusSymbol.collectCoord.reel === collector.reel && bonusSymbol.collectCoord.row === collector.row) {
          const { reel, row } = bonusSymbol.coin.coord;
          const freeSpinsCount = bonusSymbol.coin.freeSpinsCount;

          const bonusSymbolID = gameController.symbolMap.find(
            (symbol) => symbol.cell.reel === reel && symbol.cell.row === row
          ).symbolId;

          spineSymbolAnimator.animate([
            {
              cell: { reel: reel, row: row },
              symbolId: bonusSymbolID,
            },
          ]);

          // get particle emitter for this bonus symbol
          const bonusTempParticle = this.tempParticles.find(
            (tempParticle) => tempParticle.award.coin.coord.reel === reel && tempParticle.award.coin.coord.row === row
          );
          bonusTempParticle.emitter.particleEmitter.emit = true;
          bonusTempParticle.emitter.visible = true;

          this.particleTweensInProgress = true;

          soundManager.play("coinWhoosh");
          const xOnlyTween = this.smartTweens.tween(
            bonusTempParticle.emitter.particleEmitter.spawnPos,
            this.freeSpinsCounterValue,
            bonusTempParticle.emitter,
            { ease: "linear", duration: 0.5, y: false },
            false
          );

          const yOnlyTween = this.smartTweens.tween(
            bonusTempParticle.emitter.particleEmitter.spawnPos,
            this.freeSpinsCounterValue,
            bonusTempParticle.emitter,
            { ease: "power3.in", duration: 0.5, x: false },
            false
          );
          await Promise.all([yOnlyTween, xOnlyTween]);
          this.particleTweensInProgress = false;

          bonusTempParticle.emitter.particleEmitter.emit = false;
          bonusTempParticle.emitter.visible = false;

          //update the free spins counter text with the correct value
          let spinsDone;
          let totalSpins;

          // if already in free spins then it is a retrigger
          if (gameController.inFreeSpins) {
            spinsDone =
              gameController.freeSpinsController._freespinsCount - gameController.freeSpinsController._spinsLeft;
            totalSpins = gameController.freeSpinsController._freespinsCount + freeSpinsCount;

            gameController.freeSpinsController._freespinsCount += freeSpinsCount;
            gameController.freeSpinsController._spinsLeft += freeSpinsCount;
          } else {
            spinsDone = 0;
            totalSpins = freeSpinsAmountsAdded + freeSpinsCount;
          }

          this.freeSpinsCounterValue.setTranslationParameters(spinsDone, totalSpins);
          this.freeSpinsCounterValue.visible = true;
          freeSpinsAmountsAdded += freeSpinsCount;

          // bounce free spins counter value
          await gsap
            .timeline({ repeat: 1 })
            .to(this.freeSpinsCounterValue, { y: "-=25", ease: "bounce.in", duration: 0.2 })
            .to(this.freeSpinsCounterValue, { y: "+=25", ease: "bounce.out", duration: 0.2 });

          // if we're i free spins then must be a retrigger
          gameController.inFreeSpins && (await this.bonusCollectionFreeSpinsRetrigger(freeSpinsCount));
        }
      }
    }
  },

  async bonusCollectionFreeSpinsRetrigger(numberOfFreespins) {
    gameController.canSkipWin = false;
    gameController.coinsCurrentlySkippable = false;

    gameController.freeSpinsController._retriggerPopup.visible = true;
    gameController.freeSpinsController._retriggerPopup.alpha = 0;
    gameController.dimNoneWinningSymbolsBySymbolGroup([]);

    soundManager.play("hbc_whoosh_v1");

    gameController.freeSpinsController._freespinsRetriggerValue.setText("+" + numberOfFreespins);

    // fade in retrigger popup
    await gsap.to(gameController.freeSpinsController._retriggerPopup, { duration: 1, alpha: 1 });

    const popup = gameController.freeSpinsController._retriggerPopup.position;
    const baseY = popup.y;

    await gsap
      .timeline({
        defaults: {
          duration: 0.5,
          ease: "linear",
        },
        repeat: 2,
        yoyo: true,
      })
      .to(popup, { y: baseY + 5 });

    // fade in retrigger popup
    await gsap.to(gameController.freeSpinsController._retriggerPopup, { duration: 0.5, alpha: 0 });
  },

  async collectionTotalWinningAnimation() {
    let showTopWinCountup;

    // if there's only cash fish showing (no symbol wins) then dont show top win countup
    if (gameController.lastPayWinsData || gameController.isFreeSpinsTrigger || gameController.inFreeSpins) {
      showTopWinCountup = true;
    }

    let totalToCollect = this.collectorBoxes.reduce((sum, box) => sum + box.runningTotal, 0);
    gameController.coinWinnings = totalToCollect;

    const collectionPromises = [];

    let delay = 0.5;
    const duration = 1;
    if (!showTopWinCountup) {
      delay = 0.2;
    }

    // COUNT DOWN AMOUNT OF TEXT COLLECTION BOXES
    const boxPromises = this.collectorBoxes.map((collectorBox) => {
      return this.smartTweens.timeline(() =>
        gsap.timeline({ delay: delay }).to(collectorBox, {
          runningTotal: 0,
          duration: duration,
          ease: Circ.easeOut,
          onUpdate() {
            collectorBox.collectBoxText.text = gdk.formatCurrency(collectorBox.runningTotal);
          },
        })
      );
    });

    collectionPromises.push(...boxPromises);

    let cashCoinWinningsContainer;
    if (showTopWinCountup) {
      cashCoinWinningsContainer = resourceManager.get("postReels:cashCoinAmountContainer");
      const cashCoinWinningsAmountText = gameController.cashCoinAmountText;
      cashCoinWinningsAmountText.setText(gdk.formatCurrency(0));

      const totalCounter = { value: 0 };
      soundManager.play("boardAppear");
      cashCoinWinningsContainer.alpha = 1;
      cashCoinWinningsContainer.visible = true;
      cashCoinWinningsAmountText.visible = true;
      const totalPromise = this.smartTweens.timeline(() =>
        gsap.timeline({ delay: delay }).to(totalCounter, {
          value: totalToCollect,
          duration: duration,
          ease: Circ.easeOut,
          snap: { value: 1 },
          onStart() {
            soundManager.play("coinCountUpLoop");
          },
          onUpdate() {
            cashCoinWinningsAmountText.setText(gdk.formatCurrency(totalCounter.value));
          },
        })
      );
      collectionPromises.push(totalPromise);
    }

    const stake = resourceManager.getController("stakeController").CurrentStake;
    // total winnings greater than stake?
    const smallWinCountupToShow = gameController.totalWinnings > stake;

    // only mark cashCoinsAnimationsComplete = true if the smallWinCountup is to actually show.
    // * if its not to show and we resolve this early, spin button is enabled too quickly.
    if (!showTopWinCountup && smallWinCountupToShow) {
      timerManager.delayAsync(delay, undefined, () => {
        gameController.cashCoinsAnimationsComplete = true;
      });
    }

    await Promise.all(collectionPromises);

    soundManager.stop("coinCountUpLoop");
    soundManager.play("coinCountUpEnd");

    gameController.canSkipWin = false;
    gameController.coinsCurrentlySkippable = false;
    showTopWinCountup && (await gsap.to(cashCoinWinningsContainer, { duration: 0.5, alpha: 0, delay: 1 }));
    //soundManager.play("addToCredit");
  },

  playWinCountupSound() {},

  async orientationChange() {
    this.tempCashTexts.length && this.positionTempTexts();
    this.collectorBoxes.length && this.positionCollectorBoxes();
    this.tempCashPotTexts.length && this.positionTempPotCashTexts();
    this.tempParticles.length && this.positionTempParticles();

    //this.smartTweens.recalculate();
  },

  skipTweens() {
    this.smartTweens.skipAll();
  },

  reset() {
    // dont remove collector boxes if it is golden spins
    const goldenSpinsHappening =
      gameController.inFreeSpins && gameController.goldenSpins.isAwarded && GoldenSpins.goldenSpins.spins.length > 0;
    if (!goldenSpinsHappening) {
      this.collectorBoxes.forEach((cb) => {
        const collectBox = cb.collectBox;
        resourceManager.destroyObject(collectBox.name);
      });
      this.collectorBoxes = [];
    }

    this.tempCashTexts.forEach((tc) => {
      const tempText = tc.tempText;
      resourceManager.destroyObject(tempText.name);
    });
    this.tempCashPotTexts.forEach((tcp) => {
      const tempText = tcp.tempText;
      resourceManager.destroyObject(tempText.name);
    });
    this.tempParticles.forEach((tp) => {
      const emitter = tp.emitter;
      resourceManager.destroyObject(emitter.name);
    });

    this.tempCashTexts = [];
    this.tempCashPotTexts = [];
    this.tempParticles = [];
    this.collectorRunningTotal = 0;
  },
};

CoinCollectionModel = {
  //PARAMS\\
  coinAwards: [],
  collectorSymbolsOnReel: [],
  collectableSymbolsOnReel: {
    cashSymbols: [],
    prizePotSymbols: [],
    bonusSymbols: [],
  },

  /**
   * Get all of the collector symbols (e.g. Fisherman Symbol) on the reel
   * @param {*} coinAwards
   */
  getCollectorSymbolsOnReel(coinAwards) {
    this.collectorSymbolsOnReel = coinAwards
      .map((i) => i.collectCoord)
      .filter((coord, index, arr) => index === arr.findIndex((c) => c.reel === coord.reel && c.row === coord.row));
  },

  /**
   * Get all of the collectable symbols (e.g. Cash Fish) on the reel
   */
  getCollectableSymbolsOnReel(coinAwards) {
    this.coinAwards = coinAwards;
    this._getCashSymbolsOnReel();
    this._getPrizePotSymbolsOnReel();
    this._getBonusSymbolsOnReel();
  },

  /**
   * Get cash symbols on reel
   */
  _getCashSymbolsOnReel() {
    this.collectableSymbolsOnReel.cashSymbols = this.coinAwards.filter(
      (collectable) => collectable.coin.type === "Cash"
    );
  },

  /**
   * Get prize pot symbols on reel
   */
  _getPrizePotSymbolsOnReel() {
    this.collectableSymbolsOnReel.prizePotSymbols = this.coinAwards.filter(
      (collectable) => collectable.coin.type === "Pot"
    );
  },

  /**
   * Get bonus symbols on reel
   */
  _getBonusSymbolsOnReel() {
    this.collectableSymbolsOnReel.bonusSymbols = this.coinAwards.filter(
      (collectable) => collectable.coin.type === "Bonus"
    );
  },

  /**
   * Sort the coins from coinAwards
   */
  sortCoins(coinAwards, isRespins, inFreespins) {
    // just default to all the coin awards
    let actualCoinsAwards = coinAwards.coins;

    if (isRespins) {
      // get all the new coins (not the ones current on the reels)
      const allNewCoins = CloverRespins.respinData.respins.flatMap((respin) => respin.newCoins);
      actualCoinsAwards = coinAwards.coins.filter(
        (award) =>
          !allNewCoins.some(
            (newCoin) =>
              newCoin.coord.reel === award.coin.coord.reel &&
              newCoin.coord.row === award.coin.coord.row &&
              newCoin.type === award.coin.type
          )
      );
    }

    const sortedCoinAwards = actualCoinsAwards.sort((a, b) => {
      // First, sort by reel
      if (a.coin.coord.reel !== b.coin.coord.reel) {
        return a.coin.coord.reel - b.coin.coord.reel;
      }
      // If reels are the same, sort by row
      return a.coin.coord.row - b.coin.coord.row;
    });

    return sortedCoinAwards;
  },
};

CoinCollectionController = {
  // collect all at once rather than one after another
  animateCollectablesTogether: true,

  // if there are 2+ collects, do we collect all together or do 1st collect, then 2nd collect
  multiCollectSequentially: true,

  // are we colleting to a progression bar before collecting cash values?
  initialCollectToProgression: true,

  isRespins: false,
  inFreespins: false,
  currentlyCollectiong: false,

  initialise() {
    CoinCollectionView.initialise();
  },

  async doCollection() {
    let coinAwards = {};
    this.inFreeSpins = gameController.inFreeSpins;

    if (this.inFreeSpins) {
      if (GoldenSpins.goldenSpins.isAwarded && GoldenSpins.isGoldenSpin) {
        coinAwards.coins = GoldenSpins.currentSpin.coinAwards;
      } else {
        coinAwards = gameController.coinAwardsBeforeGoldenSpins;
      }
    } else {
      coinAwards = gameController.coinAwards;
    }

    const isCoinAwards = coinAwards.coins.length > 0;

    if (isCoinAwards) {
      this.inFreeSpins = gameController.inFreeSpins;
      this.isRespins = !this.inFreeSpins && CloverRespins.respinData.isAwarded && !gameController.cloverRespinsComplete;
      this.hasBeenRespins =
        !this.inFreeSpins && CloverRespins.respinData.isAwarded && gameController.cloverRespinsComplete;

      this.setData(CoinCollectionModel.sortCoins(coinAwards, this.isRespins, this.inFreeSpins));
      CoinCollectionView.createTempAssets();

      if (this.isRespins) {
        await this.doRespins();
      } else {
        const isCoinAwards = coinAwards.coins.length > 0;
        if (isCoinAwards) {
          if (this.initialCollectToProgression && !this.inFreeSpins && !this.hasBeenRespins) {
            await CoinCollectionView.doProgressionBarCollection();

            // delay before starting cash collection
            await timerManager.delayAsync(1000);
          }

          const hasCash =
            CoinCollectionModel.collectableSymbolsOnReel.cashSymbols.length ||
            CoinCollectionModel.collectableSymbolsOnReel.prizePotSymbols.length;

          if (hasCash) {
            this.currentlyCollectiong = true;
            await CoinCollectionView.doCashCollection();
            this.currentlyCollectiong = false;
          }

          // Add bonus symbols to free spins counter
          if (CoinCollectionModel.collectableSymbolsOnReel.bonusSymbols.length) {
            await CoinCollectionView.doBonusCollection();
          }
        }
      }

      // DO ANY GOLDEN SPINS
      this.checkDoGoldenSpins();
      this.checkCompleted();
    }
  },

  async doRespins() {
    await CoinCollectionView.doProgressionBarCollection();
    await CloverRespins.showIntro();
    CloverRespins.start();
  },

  async checkDoGoldenSpins() {
    if (this.inFreeSpins && gameController.goldenSpins.isAwarded && GoldenSpins.goldenSpins.spins.length > 0) {
      await GoldenSpins.showIntro();
      await GoldenSpins.start();
    }
  },

  async checkCompleted() {
    const goldenSpinsHappening =
      this.inFreeSpins && gameController.goldenSpins.isAwarded && GoldenSpins.goldenSpins.spins.length > 0;

    const hasBeenGoldenSpins = this.inFreeSpins && gameController.goldenSpins.isAwarded;

    const hasCash =
      CoinCollectionModel.collectableSymbolsOnReel.cashSymbols.length ||
      CoinCollectionModel.collectableSymbolsOnReel.prizePotSymbols.length;

    if (!this.isRespins && !goldenSpinsHappening && !this.currentlyCollectiong) {
      hasCash && (await CoinCollectionView.collectionTotalWinningAnimation());
      CoinCollectionView.reset();
      gameController.cashCoinsAnimationsComplete = true;

      if (hasBeenGoldenSpins) {
        GoldenSpins.restoreCounter();
        musicManager.onGoldenSpinsEnd();
      }

      this.hasBeenRespins && musicManager.onCloverRespinsEnd();
    } else {
      CoinCollectionView.reset();
      gameController.canSkipWin = false;
      gameController.coinsCurrentlySkippable = false;
    }
  },

  setData(coinAwards) {
    CoinCollectionModel.getCollectorSymbolsOnReel(coinAwards);
    CoinCollectionModel.getCollectableSymbolsOnReel(coinAwards);
  },

  skipWins() {
    //if (CoinCollectionView.cashTextTweensInProgress) {
    CoinCollectionView.skipTweens();
    //}
  },
};
